import type {
  Article,
  Blog as IBlog,
} from "@shopify/hydrogen/storefront-api-types";
import { CustomLink } from "@components/atoms/custom-link";
import { Blog } from "@components/molecules/blog";
import { useMemo } from "react";

interface Props {
  blogs: IBlog[];
  closeSearch?: () => void;
}

function useBlogListGrid(blogs: IBlog[]) {
  const result = useMemo(() => {
    const blogsNews = blogs.find((blog) => blog.title === "News");
    const newsArticles = blogsNews
      ? blogsNews.articles.nodes.map((article: Article) => ({
          ...article,
          blogTitle: blogsNews.title,
        }))
      : [];
    const blogsEducational = blogs.find((blog) => blog.title === "Educational");
    const educationalArticles = blogsEducational
      ? blogsEducational.articles.nodes.map((article) => ({
          ...article,
          blogTitle: blogsEducational.title,
        }))
      : [];
    const combinedBlogs = newsArticles.concat(educationalArticles);

    return combinedBlogs.slice(0, 6);
  }, [blogs]);

  return {
    models: {
      result,
    },
  };
}

export function BlogListGrid({ blogs, closeSearch }: Props) {
  const { models } = useBlogListGrid(blogs);
  return (
    <>
      <div className="hidden sm:flex flex-wrap gap-3 min-h-40 mt-4 mb-14">
        {models.result.map((article) => (
          <Blog
            closeSearch={closeSearch}
            tag={article.blogTitle}
            blog={article}
          />
        ))}
      </div>
      <div className="flex flex-col gap-y-4 mt-4 mb-14 sm:hidden">
        {models.result.map((article) => (
          <CustomLink
            className="text-sm"
            closeSearch={closeSearch}
            to={article.handle}
          >
            {article.title}
          </CustomLink>
        ))}
      </div>
    </>
  );
}
